export const TRAINING_CUSTOM_ASSIGNEE_ACHIEVED_FIELD_NAME = "achieved";
export const TRAINING_CUSTOM_ASSIGNEE_REMARKS_FIELD_NAME = "remarks";
